import dashboard from './dashboard';
import recordings from './recordings';

const menuItems = {
  items: [dashboard, recordings],
};

export default menuItems;
